import styled from "styled-components";
import { monolithMoment } from "../../../utils/date-format";
import * as Tooltip from "@radix-ui/react-tooltip";
import { CopyableDetailRow } from "@/components/EntityInfo";

const NoteTooltipContent = styled(
  ({
    className,
    children,
    item: noteData,
    tooltipProps = {},
    contentProps = {},
  }) => {
    const isFolder = noteData?.is_folder === 1;
    const createdOn = noteData?.created_on
      ? monolithMoment({
          timestamp: noteData?.created_on,
          includeTime: true,
          includeZone: true,
        })
      : null;
    const updatedOn = noteData?.updated_at
      ? monolithMoment({
          timestamp: noteData?.updated_at,
          includeTime: true,
          includeZone: true,
        })
      : null;
    const pathDisplay = `${noteData?.object_name || ""} \\ ${
      noteData?.path?.split("\\")?.join(" \\ ") || noteData?.note_tag
    }`;

    return (
      <Tooltip.Provider
        delayDuration={600}
        skipDelayDuration={1}
        {...tooltipProps}
      >
        <Tooltip.Root>
          <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
          <Tooltip.Portal>
            <Tooltip.Content
              className={className + " tooltip-content"}
              side="right"
              sideOffset={5}
              align="start"
              collisionPadding={20}
              onClick={(e) => e.stopPropagation()}
              onPointerDownOutside={(e) => {
                e.preventDefault();
              }}
              {...contentProps}
            >
              <div className="title">{noteData?.note_tag || "Note Info"}</div>

              <CopyableDetailRow
                label="Linked To"
                value={noteData?.object_name}
              />
              <CopyableDetailRow
                label="Created By"
                value={noteData?.created_by?.full_name}
              />
              <CopyableDetailRow label="Created On" value={createdOn} />
              {!isFolder && (
                <CopyableDetailRow
                  label="Updated By"
                  value={noteData?.updated_by?.full_name}
                />
              )}
              {!isFolder && (
                <CopyableDetailRow label="Updated On" value={updatedOn} />
              )}
              {isFolder && (
                <CopyableDetailRow
                  label="Total Notes"
                  value={noteData?.note_count || 0}
                />
              )}
              <CopyableDetailRow label="Path" value={pathDisplay} />
              <CopyableDetailRow label="Note ID" value={noteData?.uuid} />
            </Tooltip.Content>
          </Tooltip.Portal>
        </Tooltip.Root>
      </Tooltip.Provider>
    );
  }
)`
  &.tooltip-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    z-index: 99999;
    color: ${({ theme }) => theme.palette.text.primary};
    background-color: ${({ theme }) => theme.palette.background.default};
    padding: 15px;
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    font-size: 0.75rem;
    max-width: 500px;
    user-select: text;

    .title {
      font-size: 0.85rem;
      font-weight: 600;
      margin-bottom: 15px;
    }
  }
`;

export default NoteTooltipContent;
